import { render, staticRenderFns } from "./ProgressBar.vue?vue&type=template&id=fe530bba&scoped=true&"
import script from "./ProgressBar.vue?vue&type=script&lang=ts&"
export * from "./ProgressBar.vue?vue&type=script&lang=ts&"
import style0 from "./ProgressBar.vue?vue&type=style&index=0&id=fe530bba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe530bba",
  null
  
)

export default component.exports